import { connect } from 'react-redux';
import { flatten, get, intersectionBy, map, values } from 'lodash/fp';

import performanceSelector from 'app/selectors/performanceSelector';
import TeamPerformanceTable from 'app/components/challenge/TeamPerformanceTable';
import {
  filterEntryStatus,
  resetOpponentEntry,
  setPerformanceDiff
} from 'app/actions/challengeActions';
import { isInProgress } from '../../utils/challengeUtils';

function mapStateToProps(state) {
  const { challenge, entry, settings, user } = state;
  const hasOpponent = entry.myEntry.id !== entry.opponentEntry.id;

  let commonPlayerIds = [];
  let commonTeamIds = [];

  if (entry.myEntry.playersSubmitted && entry.opponentEntry.playersSubmitted) {
    const myPlayers = flatten(values(entry.myEntry.playersSubmitted));
    const opponentPlayers = flatten(values(entry.opponentEntry.playersSubmitted));

    if (myPlayers && opponentPlayers) {
      commonPlayerIds = map('idStr')(intersectionBy('idStr', myPlayers, opponentPlayers));
    }
  }

  if (entry.myEntry.teamsSubmitted && entry.opponentEntry.teamsSubmitted) {
    const myTeams = flatten(values(entry.myEntry.teamsSubmitted));
    const opponentTeams = flatten(values(entry.opponentEntry.teamsSubmitted));

    if (myTeams && opponentTeams) {
      commonTeamIds = map('idStr')(intersectionBy('idStr', myTeams, opponentTeams));
    }
  }

  const selection = performanceSelector(state);
  const placeholders = [];

  if (hasOpponent && get('opponentScheduledPlayerCount', entry) > 0 && !get('myEntry.id', entry)) {
    for (let i = 0; i < get('opponentScheduledPlayerCount', entry); i += 1) {
      placeholders.push({
        entities: [[undefined, {}]]
      });
    }
  }

  return {
    commonPlayerIds,
    commonTeamIds,
    comparison: placeholders.length > 0 ? selection.concat(placeholders) : selection,
    diffValue: hasOpponent ? entry.restrictToUnique : false,
    displayPlayersCount: isInProgress(challenge.statusId) && challenge.games.length > 1,
    displayWidget: settings.displayWidget,
    entryCount: challenge.entryCount,
    isLoading: entry.isLoadingOpponent,
    isRacing: challenge.isRacing,
    myAvatar: get('currentUser.avatar', user),
    myEntry: entry.myEntry,
    opponentEntry: hasOpponent ? entry.opponentEntry : undefined,
    statusFilters: entry.statusFilters
  };
}

const actions = {
  onComparisonReset: resetOpponentEntry,
  onPerformanceDiffChange: setPerformanceDiff,
  onStatusSelect: filterEntryStatus
};

export default connect(mapStateToProps, actions)(TeamPerformanceTable);
